import Content from './content-interface';

export default class SetInstanceRegisteredHistory implements Content {
  instance: string;

  constructor(obj: any = {}) {
    this.instance = obj.instance || '';
  }

  public static of(obj: any = {}): SetInstanceRegisteredHistory {
    return new SetInstanceRegisteredHistory(obj);
  }
}
